import api from "../../../api";

export default {
  async getMySelf({ commit }, options = {}) {
    commit("REQUEST_MYSELF");
    if (!options.silent) commit("SET_LOADING", true, { root: true });
    try {
      commit("SUCCESS_REQUEST_MYSELF", await api.mySelf());
    } catch (err) {
      //console.log("FAILURE_REQUEST_MYSELF")
      commit("TO_LOGIN", true, { root: true });
      //commit("FAILURE_REQUEST_MYSELF");
    } finally {
      if (!options.silent) commit("SET_LOADING", false, { root: true });
    }
  },
  async authenticate({ commit, dispatch }, { email, password }) {
    window.sessionStorage.removeItem("SupportAuthorization");
    window.sessionStorage.removeItem("SupportWindow");
    commit("REQUEST_AUTH");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_AUTH",
        await api.authenticate({ email, password })
      );
    } catch (err) {
      commit("FAILURE_REQUEST_AUTH");
    } finally {
      commit("SET_LOADING", false, { root: true });

      dispatch("getMySelf");
    }
  },
  async logout() {
    if (window.sessionStorage.getItem("SupportAuthorization")) {
      try {
        await api.endSupportSession();
      } catch (err) {
        // The support token may already be expired or revoked.
      }
      window.sessionStorage.removeItem("SupportAuthorization");
      window.close();
      return;
    }
    window.localStorage.removeItem("Authorization");
    window.location.reload();
  },
  async updateDashboardSettings({ commit }, settings) {
    try {
      await api.updateDashboardSettings(settings);
      // Settings wurden gespeichert
    } catch (err) {
      console.error("Error updating dashboard settings:", err);
    }
  }
};
